<template>
    <div>
        <b-form @submit.prevent="saveRuleIndicationOfDanger()" data-vv-scope="formRuleIndicationOfDanger">
            <b-row>
                <b-col md="12">
                    <b-form-group>
                        <label>Nombre <span class="text-danger">*</span></label>
                        <b-form-input v-model="ruleIndicationOfDanger.name" type="text" class="form-control" name="name"
                            v-validate="'required'" data-vv-as=" " />
                        <span class="text-danger small" v-text="errors.first('formRuleIndicationOfDanger.name')" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label>Indicaciones de peligro que conforman la regla <span class="text-danger">*</span></label>
                        <el-select @change="toggleCombination"
                            v-model="ruleIndicationOfDanger.sga_danger_indication_code_combination_ids" clearable
                            filterable multiple size="medium" placeholder="Seleccionar indicación de peligro"
                            name="sga_danger_indication_code_combination_ids" v-validate="'required'" data-vv-as=" ">
                            <el-option v-for="item in activeIndicationsOfDangerSga" :key="item.id"
                                :label="item.code + ' - ' + item.name" :value="item.id" />
                        </el-select>
                        <span class="text-danger small"
                            v-text="errors.first('formRuleIndicationOfDanger.sga_danger_indication_code_combination_ids')" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label>Indicaciones de peligro a mostrar <span class="text-danger">*</span></label>
                        <el-select v-model="ruleIndicationOfDanger.sga_danger_indication_code_display_ids" clearable
                            filterable multiple size="medium" placeholder="Seleccionar indicación de peligro"
                            name="sga_danger_indication_code_display_ids" v-validate="'required'" data-vv-as=" ">
                            <el-option v-for="item in indicationOfDangerCodeDisplays" :key="item.id"
                                :label="item.code + ' - ' + item.name" :value="item.id" />
                        </el-select>
                        <span class="text-danger small"
                            v-text="errors.first('formRuleIndicationOfDanger.sga_danger_indication_code_display_ids')" />
                    </b-form-group>
                </b-col>

                <b-col md="12" class="mt-3 d-flex justify-content-end align-items-center">
                    <b-form-group>
                        <b-button variant="danger" @click="cancelRuleIndicationOfDanger">
                            <i class="fa fa-reply"></i>
                            <span class="ml-1" v-text="'Cancelar'"></span>
                        </b-button>
                        <b-button type="submit" variant="primary" class="mx-1">
                            <i class="fa fa-save"></i>
                            <span class="ml-1" v-text="'Guardar'"></span>
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
    name: 'FormRulesIndicationsOfDanger',
    data() {
        return {
            indicationOfDangerCodeDisplays: [],
        };
    },

    computed: {
        ...mapState('sgaRulesIndicationsOfDanger', ['action', 'ruleIndicationOfDanger']),
        ...mapState('sgaIndicationsOfDanger', ['activeIndicationsOfDangerSga']),
        ...mapState('sgaVersions', ['activeGlobalVersion']),
    },

    async created() {
        await this.getActiveIndicationsOfDangerSga();
        this.toggleCombination();
    },
    methods: {
        ...mapActions('sgaRulesIndicationsOfDanger', ['createRuleIndicationOfDangerSga', 'getRulesIndicationsOfDangerSga', 'updateRuleIndicationOfDangerSga']),
        ...mapMutations('sgaRulesIndicationsOfDanger', ['setDefaultRuleIndicationOfDangerSga']),
        ...mapActions('sgaIndicationsOfDanger', ['getActiveIndicationsOfDangerSga']),

        cancelRuleIndicationOfDanger() {
            this.setDefaultRuleIndicationOfDangerSga();
            this.$bvModal.hide('modal_create_rules_indication_danger');
        },

        async cancelAndGetRulesIndicationOfDanger() {
            this.cancelRuleIndicationOfDanger();
            await this.getRulesIndicationsOfDangerSga();
        },

        async saveRuleIndicationOfDanger() {
            const isValid = await this.$validator.validateAll('formRuleIndicationOfDanger');
            if (!isValid) return;

            this.ruleIndicationOfDanger.version_id = this.activeGlobalVersion;

            let flag = false;
            if (this.action === 'edit') {
                flag = await this.updateRuleIndicationOfDangerSga(this.ruleIndicationOfDanger);
            } else {
                flag = await this.createRuleIndicationOfDangerSga(this.ruleIndicationOfDanger);
            }

            if (flag) {
                this.cancelAndGetRulesIndicationOfDanger();
            }
        },

        // Listar las indicaciones de peligro a mostrar a partir de la combinación de indicaciones de peligro
        toggleCombination() {
            this.indicationOfDangerCodeDisplays = this.activeIndicationsOfDangerSga.filter((item) => {
                return this.ruleIndicationOfDanger.sga_danger_indication_code_combination_ids.includes(item.id);
            });
        },
    }
}
</script>
